import React from 'react';
import { noop } from 'lodash-es';
import { styled, border } from '@elliemae/ds-system';
import { Grid } from '@elliemae/ds-grid';
import { DSCheckbox } from '@elliemae/ds-legacy-form';
import { Checkmark } from '@elliemae/ds-icons';
import { DSMobileTouchable } from '../MobileTouchable/index.js';
import { DSMobileListItem } from '../MobileListItem/index.js';

export const StyledContainer = styled(Grid)`
  background: ${(props) => props.theme.colors.neutral['000']};
  z-index: ${(props) => props.zIndex};
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
`;

export const HeaderContainer = styled(Grid)`
  border-bottom: ${(props) => border(props.theme.colors.neutral['300'])};
`;

export const Footer = styled(Grid)`
  border-top: ${(props) => border(props.theme.colors.neutral['300'])};
`;

export const ListContainer = styled.div`
  & ${DSMobileTouchable}:last-child ${DSMobileListItem} {
    border: none;
  }
`;

export const checkbox = <DSCheckbox checked={false} onChange={noop} style={{ pointerEvents: 'none' }} />;
export const checked = <DSCheckbox checked onChange={noop} style={{ pointerEvents: 'none' }} />;
export const selectedMark = <Checkmark color={['brand-primary', 600]} />;
